import { useLocation } from "react-router";
import { PICO_APPS } from "jadro-pico/apps/picoApps";
import { getOriginApp } from "../App/originApp";
import { isRequestQueuePath } from "./isRequestQueuePath";

// An app that never registered these routes would otherwise lose its shell on a hand-typed queue
// URL and leave the user on a blank page with no navigation off it.
function hostsRequestQueue(): boolean {
  const app = getOriginApp();
  return PICO_APPS.some((entry) => entry.id === app && entry.hasRequestQueue);
}

// The queue pages bring their own frame, so the app shell has to stop drawing one around them.
export function useIsRequestQueueRoute(): boolean {
  const { pathname } = useLocation();
  return hostsRequestQueue() && isRequestQueuePath(pathname);
}
